import angular from 'angular';
import {ProductsConfig} from './config'
import MaterialsComponent from './components/materials';
import MaterialSpecComponent from './components/material-spec';
import MaterialShapeSpecComponent from './components/material-shape-spec';
import MaterialColorSpecComponent from './components/material-color-spec';
import MaterialFixmethodSpecComponent from './components/material-fixmethod-spec';
import MaterialMode from './components/material-mode';
import MaterialPricing from './components/material-pricing';
import ProductsService from './services/products.service';
import ProductsDataProvider from './services/products.dataprovider.service';
import uiRouter from 'angular-ui-router';
import runFunc from './run';

export default angular.module('products', [uiRouter])
  .component('productMaterials', MaterialsComponent)
  .component('productMaterialSpec', MaterialSpecComponent)
  .component('materialShapes', MaterialShapeSpecComponent)
  .component('materialColors', MaterialColorSpecComponent)
  .component('materialFixmethods', MaterialFixmethodSpecComponent)
  .component('materialMode', MaterialMode)
  .component('productMaterialPricing', MaterialPricing)
  .service('ProductsService', ProductsService)
  .service('ProductsDataProvider', ProductsDataProvider)
  .config(ProductsConfig)
  .run(runFunc)

  .name


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/index.js
 **/